module.exports = __webpack_public_path__ + "img/square-n.25701c69.svg";